
import { Request } from "@cttq/cttq-request";

let serverInstance = new Request({
  	baseURL: import.meta.env.VITE_CENSOR_URL,
	headers: {
		"Content-Type": "application/json",
		reqSource: "ui",
	},
});


export function sensitiveApi(data:any){
	return serverInstance.request({
		method: "post",
		url: "/word/check",
		data: data,
	})
}

